import { Box } from 'shared/ui/Box';

import styled from '@emotion/styled';

export const DefaultTodoItemWrapper = styled(Box)`
  font-size: ${({ theme }) => theme.fontSizes['17']}px;

  & p {
    margin: 0 !important;
    padding: 0 !important;

  }

  .ck .ck-link_selected {
    background: white;
  !important;
    color: black;
  !important;
  }


`;
